import { CUSTOMER_LEVEL } from '@wyz/types';
import { useManageUsers } from '~/common/api';
import { useApplicationContext } from '~/common/context';

type UseMyCustomersArgs = {
  minLevel?: number;
  parentIds?: string[];
  enabled?: boolean;
};

export const useMyCustomers = ({
  minLevel = CUSTOMER_LEVEL.N1,
  parentIds = [],
  enabled = true,
}: UseMyCustomersArgs = {}) => {
  const { auth } = useApplicationContext();
  const customerQuery = useManageUsers({
    getCustomersByUser: {
      args: { id: auth.userId as string, minLevel, parentIds },
      enabled: enabled,
      refetchOnMount: true,
    },
  }).getCustomersByUser;

  return customerQuery;
};
